function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "handy_svg__a",
  x: 4.233,
  y: 9.571,
  width: 50.753,
  height: 41.844,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.686
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "handy_svg__c",
  x: 27.997,
  y: 29,
  width: 33,
  height: 32.999,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.686
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".handy_svg__d{fill:#ff6c6c}.handy_svg__f{fill:#1c1c26}.handy_svg__g,.handy_svg__h{fill:#1b1c26}.handy_svg__h{stroke:#383d5a}.handy_svg__i{stroke:none}.handy_svg__k{fill:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.337 8.571)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#383d5a"
}, /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__i",
  d: "M45.65 33.844H8.895c-1.103 0-2-.897-2-2V2c0-1.103.897-2 2-2h12.68l3.767 4.631.3.369H45.65c1.103 0 2 .897 2 2v24.844c0 1.103-.897 2-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.896 1c-.551 0-1 .449-1 1v29.844c0 .552.449 1 1 1h36.753a1 1 0 001-1V7c0-.551-.448-1-1-1H25.168l-.6-.738L21.1 1H8.896m0-2h13.156l4.067 5h19.53a3 3 0 013 3v24.844a3 3 0 01-3 3H8.896a3 3 0 01-3-3V2a3 3 0 013-3z",
  fill: "#1b1c26"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.896 10)",
  stroke: "#1b1c26",
  strokeWidth: 2,
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__i",
  width: 32.753,
  height: 33.844,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__k",
  x: -1,
  y: -1,
  width: 34.753,
  height: 35.844,
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.34 -8.57)",
  filter: "url(#handy_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__d",
  width: 32.753,
  height: 23.844,
  rx: 1,
  transform: "translate(13.23 18.57)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.896 12)",
  stroke: "#1b1c26",
  strokeWidth: 2,
  fill: "#383d5a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__i",
  width: 46.753,
  height: 33.844,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__k",
  x: 1,
  y: 1,
  width: 44.753,
  height: 31.844,
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__f",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(10.66 3.429)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "handy_svg__f",
  width: 6,
  height: 2,
  rx: 1,
  transform: "translate(14.66 3.429)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__g",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  transform: "translate(30.662 25.429)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.34 -8.57)",
  filter: "url(#handy_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__d",
  d: "M51.454 44.837a2.672 2.672 0 01-1.575-1.5 2.724 2.724 0 01.047-2.184.81.81 0 00-1.078-1.078 2.724 2.724 0 01-2.184.047 2.672 2.672 0 01-1.5-1.575.809.809 0 00-1.528 0 2.713 2.713 0 01-3.694 1.528.764.764 0 00-.919.159.792.792 0 00-.159.919 2.682 2.682 0 01-1.528 3.684.772.772 0 00-.337.684.932.932 0 00.422.881 2.654 2.654 0 011.5 1.472 2.689 2.689 0 01-.056 2.184.81.81 0 001.078 1.078 2.672 2.672 0 012.184-.056 2.731 2.731 0 011.509 1.584c.112.234.506.338.787.338a.816.816 0 00.759-.394 2.684 2.684 0 013.665-1.472.777.777 0 00.919-.159.764.764 0 00.159-.919 2.713 2.713 0 011.528-3.694.809.809 0 000-1.528zm-6.956 4.415a3.745 3.745 0 113.75-3.75 3.747 3.747 0 01-3.75 3.75z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__g",
  d: "M11.555 21.199a3.53 3.53 0 013.53 3.53v.231a.392.392 0 01-.392.392H8.417a.392.392 0 01-.392-.392v-.231a3.53 3.53 0 013.53-3.53zm10.782 0a3.53 3.53 0 013.53 3.53v.231a.392.392 0 01-.392.392h-6.276a.392.392 0 01-.392-.392v-.231a3.53 3.53 0 013.53-3.53z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__g",
  cx: 1.869,
  cy: 1.869,
  transform: "translate(9.687 16.462)",
  r: 1.869
}), /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__g",
  cx: 1.869,
  cy: 1.869,
  transform: "translate(20.469 16.462)",
  r: 1.869
}), /*#__PURE__*/React.createElement("g", {
  className: "handy_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__i",
  d: "M16.946 21.16a4.21 4.21 0 014.21 4.21v.276a.468.468 0 01-.468.468h-7.484a.468.468 0 01-.468-.469v-.275a4.21 4.21 0 014.21-4.21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__k",
  d: "M16.946 20.66a4.71 4.71 0 014.71 4.71v.5a.744.744 0 01-.744.744H12.98a.744.744 0 01-.744-.745v-.5a4.71 4.71 0 014.71-4.709z"
})), /*#__PURE__*/React.createElement("g", {
  className: "handy_svg__h",
  transform: "translate(14.719 15.702)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__i",
  cx: 2.229,
  cy: 2.229,
  r: 2.229
}), /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__k",
  cx: 2.229,
  cy: 2.229,
  r: 2.729
})), /*#__PURE__*/React.createElement("path", {
  className: "handy_svg__g",
  d: "M16.946 21.16a4.21 4.21 0 014.21 4.21v.276a.468.468 0 01-.468.468h-7.484a.468.468 0 01-.468-.469v-.275a4.21 4.21 0 014.21-4.21z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "handy_svg__g",
  cx: 2.229,
  cy: 2.229,
  transform: "translate(14.719 15.702)",
  r: 2.229
})));

var SvgHandy = function SvgHandy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60.997,
    height: 61.999
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgHandy as ReactComponent };